export default {
    manage_fuelCard: "Tarjeta de Combustible",
    manage_fuelCard_cardNumberColumnTitle: "Tarjeta de Combustible",
    manage_fuelCard_vehicleColumnTitle: "Vehículo",
    manage_fuelCard_vehicleDescriptionColumnTitle: "Descripción de Vehículo",
    manage_fuelCard_unitOrDriverColumnTitle: "Unidad / Conductor",
    manage_fuelCard_tankSizeColumnTitle: "Tamaño del Tanque (Valor en Galones)",
    manage_fuelCard_search_by_fuel_card_number: "Buscar por Tarjeta de Combustible o Tamaño del Tanque"
}